import { render } from "./TasksTransmitterRelatedListView.vue?vue&type=template&id=1ccbb587"
import script from "./TasksTransmitterRelatedListView.vue?vue&type=script&lang=js"
export * from "./TasksTransmitterRelatedListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__